<template>
  <PageLayout>
    <template #headerTitle>
      <span class="whitespace-nowrap"> Autres services </span>
    </template>
    <div class="px-6 md:px-8 mb-16 md:mb-8">
      <div class="max-w-4xl mx-auto">
        <!-- tabs navigation -->
        <div
          class="w-full rounded-full grid grid-cols-1 text-center bg-white mb-6 md:mb-8 relative"
          v-if="false"
        >
          <div
            class="absolute w-[calc(100%/1)] h-full duration-300 p-1"
            :class="{
              'translate-x-full': activeGroup == 'trade'
              // 'translate-x-[200%]': activeGroup == 'others',
            }"
          >
            <div class="w-full h-full bg-[#E8E7FF] rounded-full"></div>
          </div>
          <!-- <div
            class="py-4 md:py-6 relative rounded-full font-bold text-sm md:text-md tracking-tighter cursor-pointer"
            @click="activeGroup = 'recharges'"
          >
            Recharges & Retraits
          </div>
          <div class="py-4 md:py-6 relative rounded-full font-bold text-sm md:text-md tracking-tighter cursor-pointer" @click="activeGroup = 'trade'">
            Cryptos
          </div> -->
          <div
            class="py-4 md:py-6 relative rounded-full font-bold text-sm md:text-md tracking-tighter cursor-pointer"
            @click="activeGroup = 'others'"
          >
            Abonnements
          </div>
        </div>
        <ServicesList :grid="true" :hideDesc="true" :group="activeGroup" />
      </div>
    </div>
  </PageLayout>
</template>

<script setup>
import { ref } from 'vue';

const activeGroup = ref('others');
</script>
